/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import matchSorter from "match-sorter";
import Loading from "../common/Loading";

const TaskList = ({ tasks, search, onClickEdit }) => {
  const columns = [
    { Header: "Description", accessor: "description" },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => (row.value ? "Active" : "Inactive"),
      maxWidth: 80
    }
  ];

  const tasksToUse = search
    ? matchSorter(tasks, search, {
        keys: ["description"]
      })
    : tasks;

  return (
    <ReactTable
      className="-highlight"
      data={tasksToUse}
      LoadingComponent={() => <Loading active={!tasks.length} />}
      columns={columns}
      getTrProps={(state, rowInfo) => ({
        onClick: () => onClickEdit(rowInfo.original)
      })}
      defaultPageSize={10}
      defaultSorted={[
        {
          id: "description",
          asc: true
        }
      ]}
    />
  );
};

TaskList.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onClickEdit: PropTypes.func.isRequired,
  search: PropTypes.string
};

export default TaskList;
